export default __webpack_public_path__ + "static/media/logo-white.7a778f8b.png";